import { navigateToCrmOpsDocket } from "../../Pages/Agent/Crm/navigateToCrmOpsDocket";

/**
 * הצלחה אחרי יצירת פנייה — מעבר לדוקט CRM (צ׳אט אופרציה).
 * Drawer הצלחה רק כ-fallback אם אין לאן לנווט.
 *
 * @param {object} params
 * @param {(payload: object) => void} params.showOperationRequestSuccess
 * @param {(path: string, opts?: object) => void} [params.navigate]
 * @param {object} params.request — אובייקט request מה-API
 * @param {string|null} [params.displayOrderNumber]
 */
export async function afterOperationRequestCreateSuccess({
  showOperationRequestSuccess,
  navigate,
  request,
  displayOrderNumber,
}) {
  const displayNo =
    displayOrderNumber ?? request?.displayOrderNumber ?? null;

  console.log("[OP_REQUEST_SUCCESS_NAV_DOCKET]", {
    requestId: request?.id ?? null,
    displayOrderNumber: displayNo,
    crmLeadId: request?.crmLeadId ?? request?.crm_lead_id ?? null,
    orderId: request?.orderId ?? request?.order_id ?? null,
  });

  if (typeof navigate === "function") {
    try {
      await navigateToCrmOpsDocket(navigate, request, { replace: false });
      return;
    } catch (e) {
      console.warn("[OP_REQUEST_SUCCESS_NAV_DOCKET_FAILED]", e);
    }
  }

  if (typeof navigate === "function") {
    navigate("/p/dashboard/home");
  }
  showOperationRequestSuccess({
    request,
    displayOrderNumber: displayNo,
  });
}
